export const ASSIGNMENT_MODAL_COMMON_SIZE = 'lg';
export const ASSIGNMENT_MODAL_PADDING_TOP = { paddingTop: '10px' };
export const ASSIGNMENT_MODAL_FONT_SIZE = { fontSize: ASSIGNMENT_MODAL_COMMON_SIZE };
